import { vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "text-editor" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("textarea", {
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.text) = $event)),
      ref: "editor",
      onInput: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.updateText && _ctx.updateText(...args))),
      placeholder: "Lorem ipsum ...",
      rows: "12",
      class: "text-editor__input"
    }, null, 544), [
      [_vModelText, _ctx.text]
    ])
  ]))
}